import clientEnv from '@savvy/env/client';

export function salesforceEnvLightningURL() {
  if (clientEnv.NEXT_PUBLIC_VERCEL_ENV === 'development') {
    return 'https://savvywealthinc--delegate.sandbox.lightning.force.com';
  }
  if (clientEnv.NEXT_PUBLIC_VERCEL_ENV === 'demo') {
    return 'https://savvywealthinc--demo.sandbox.lightning.force.com';
  }
  return 'https://savvywealthinc.lightning.force.com';
}
